(() => {
  const root = document.querySelector('[data-cg-team]');
  if (!root || root.dataset.cgTeamBound) return;
  root.dataset.cgTeamBound = '1';

  const pills = Array.from(root.querySelectorAll('[data-team-variant]'));
  const countEl = root.querySelector('[data-team-count]');
  const totalEl = root.querySelector('[data-team-total]');
  const addBtn = root.querySelector('[data-team-add]');

  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return (root.dataset.moneyFormat || '{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  const selected = () => pills.filter((p) => p.classList.contains('is-on'));

  const sync = () => {
    const sel = selected();
    countEl.textContent = sel.length;
    const total = sel.reduce((s, p) => s + Number(p.dataset.price), 0);
    totalEl.textContent = sel.length ? formatMoney(total) : '';
    addBtn.disabled = sel.length === 0;
  };

  pills.forEach((pill) => {
    pill.addEventListener('click', () => {
      pill.classList.toggle('is-on');
      pill.setAttribute('aria-pressed', pill.classList.contains('is-on') ? 'true' : 'false');
      sync();
    });
  });

  const getSectionInnerHTML = (html, selector) => {
    if (!html) return null;
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : null;
  };

  // Same cart-refresh pattern as cg-quickshop.js: splice the re-rendered
  // cart-drawer and cart-icon-bubble sections returned by /cart/add.js.
  const refreshCart = (sections) => {
    document.dispatchEvent(new CustomEvent('cg:cart:added'));
    if (!sections) return;
    const cartDrawerRoot = document.querySelector('#CartDrawer');
    if (cartDrawerRoot && sections['cart-drawer']) {
      const inner = getSectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
      if (inner != null) cartDrawerRoot.innerHTML = inner;
    }
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && sections['cart-icon-bubble']) {
      const inner = getSectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (inner != null) cartIconBubble.innerHTML = inner;
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-empty');
      // The splice above replaced #CartDrawer-Overlay, dropping Dawn's click
      // binding — re-bind before opening.
      drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
      if (typeof drawer.open === 'function') drawer.open();
    }
  };

  addBtn.addEventListener('click', async () => {
    const sel = selected();
    if (!sel.length) return;
    const giftNote = document.querySelector('.cg-gift-note__field')?.value.trim();
    const items = sel.map((p, i) => {
      const item = { id: Number(p.dataset.teamVariant), quantity: 1 };
      if (giftNote && i === 0) item.properties = { 'Message cadeau': giftNote };
      return item;
    });
    addBtn.disabled = true;
    const original = addBtn.textContent;
    try {
      const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || `add.js ${res.status}`);
      addBtn.textContent = root.dataset.labelAdded || 'Ajouté';
      refreshCart(data.sections);
      pills.forEach((p) => { p.classList.remove('is-on'); p.setAttribute('aria-pressed', 'false'); });
      sync();
    } catch (err) {
      addBtn.textContent = root.dataset.labelRetry || 'Réessayer';
    } finally {
      setTimeout(() => { addBtn.textContent = original; sync(); }, 1500);
    }
  });

  sync();
})();
